import { WXFaceMap } from '../config/WXFaceConfig';

const qqCache = {};
const emojiCache = {};

WXFaceMap.forEach(item => {
    if (item.alias) {
        emojiCache[item.alias] = item.text;
    } else {
        qqCache[item.text] = `[f_${item.code}]`;
    }
});

export const parseEmoji = function(txt) {
    return txt.replace(/\[([^\[\]]*?)\]/g, function(match, p1) {
        return emojiCache[p1] || qqCache[p1] || match;
    });
};
